/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefundPaymentResponse
 */
export interface RefundPaymentResponse {
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentResponse
     */
    paymentReference: string;
}

/**
 * Check if a given object implements the RefundPaymentResponse interface.
 */
export function instanceOfRefundPaymentResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "paymentReference" in value;

    return isInstance;
}

export function RefundPaymentResponseFromJSON(json: any): RefundPaymentResponse {
    return RefundPaymentResponseFromJSONTyped(json, false);
}

export function RefundPaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundPaymentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentReference': json['paymentReference'],
    };
}

export function RefundPaymentResponseToJSON(value?: RefundPaymentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentReference': value.paymentReference,
    };
}

